// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1SUEW","errorLogs":"EditorFooter_errorLogs__M3BOA"};